import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";

// Button route config
const tabs = [
  { label: "Project List", path: `/projects` },
  { label: "Add Project", path: `/projects/new-project` },
];

export default function ProjectPage() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <section className="p-3 sm:p-4">
      {/* Tabs */}
      <div className="w-full overflow-x-auto">
        <div className="flex gap-3 items-center py-3 border-b border-gray-400 whitespace-nowrap">
          {tabs.map(({ label, path }) => {
            const isActive = location.pathname === path;
            return (
              <Button
                key={path}
                variant="outlined"
                onClick={() => navigate(path)}
                className={`!capitalize !text-[15px] !font-medium 
                  ${
                    isActive
                      ? "!bg-zinc-700 !text-white !border-none"
                      : "!bg-gray-200 !text-primary !border-zinc-400"
                  }`}
              >
                {label}
              </Button>
            );
          })}
        </div>
      </div>

      {/* Content */}
      <div className="mt-4 bg-white p-3 sm:p-4 shadow-md rounded-[4px]">
        <Outlet />
      </div>
    </section>
  );
}
